<template>
  <div class="tree">
    <div v-for="(item, index) in initData" :key="index">
      <div class="tagName">{{ item.tagName }}</div>
      <div v-for="(childItem, childIndex) in item.child" :key="childIndex">
        <span>
          {{ childItem.name }}
        </span>
        <span> {{ childItem.price }}{{ $t('元/次') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    initData: Array,
  },
}
</script>
<style lang="less" scoped>
.tree {
  height: 400px;
  overflow: auto;
  > div {
    .tagName {
      padding: 5px 10px;
      border-bottom: 1px solid #e4e4e4;
      color: #999;
    }
    > div {
      padding: 0 16px;
      line-height: 32px;
      display: flex;
      justify-content: space-between;
      > span {
        color: #666;
      }
    }
  }
}
</style>
